<template>
  <div>
    <page-loading :pageLoad="pageLoad"></page-loading>
    <template v-for="item of posts">
      <timeline-item-card
        class="mb-5"
        :item="item"
        :key="item._id"
      ></timeline-item-card>
    </template>
    <v-btn
      block
      color="white"
      elevation="0"
      @click="fetchMorePost()"
      v-if="currentPage <= maxPage"
    >
      more
    </v-btn>
  </div>
</template>

<script>
import TimelineItemCard from "@/components/TimelineItemCard.vue";
import PageLoading from "@/components/post/PageLoading.vue";
import Vue from "vue";
export default {
  components: {
    TimelineItemCard,
    "page-loading": PageLoading,
  },
  props: ["items"],
  data: () => ({
    posts: [],
    currentPage: 1,
    maxPage: 0,
    lastFetch: 0,
    pageLoad: false,
  }),
  mounted() {
    this.fetchPost();
  },
  computed: {
    courseId() {
      return this.$route.params.id;
    },
    updatePostList() {
      return this.$store.getters.updatePostList;
    },
  },
  methods: {
    fetchMorePost() {
      this.currentPage++;
      this.fetchPost();
    },
    fetchPost() {
      // this.$store.dispatch("fetchPost");
      this.pageLoad = true;
      const url = this.$store.getters.urlQueryParameter(
        `${this.$store.state.api}/post/list`,
        {
          idcourse: this.courseId,
          limit: 10,
          page: this.currentPage,
          sortby: -1,
          web: true,
          sort: "created_at",
        }
      );

      Vue.axios
        .get(url, this.$store.getters.requestHeaders)
        .then((res) => {
          if (res.data.status) {
            this.maxPage = res.data.result.maxPage;
            if (res.data.result.maxPage > this.lastFetch) {
              this.lastFetch = this.currentPage;
              this.posts.push(...res.data.result.data);
            } else {
              this.lastFetch = res.data.result.maxPage;
              this.currentPage = res.data.result.maxPage;
            }
          }
          this.pageLoad = false;
        })
        .catch((err) => {})
        .finally(() => {});
    },
  },
  watch: {
    updatePostList(newValue) {
      this.posts.unshift(newValue);
    },
  },
};
</script>
